import {
  CyberInsuranceInfo,
  CYBER_INSURANCE_DATA,
} from "../../../components/Questionnaire/Amble/CyberInsuranceInfo";

export const amble = <CyberInsuranceInfo data={CYBER_INSURANCE_DATA} />;
